import api from '@/api';
import { API_BASE_URL } from '../..';
import {
  DirectSaleDataRequest,
  DirectSaleSellerSyntheticDataRequest,
  DirectSaleSummaryPeriodDataRequest,
  DirectSaleTotalDataRequest,
  ReportDirectSalePaymentReceipt,
  ReportDirectSaleSaleSummaryFormValues,
} from './DirectSale.types';

const BASE_URL = `${API_BASE_URL}/generate`;

export async function generateDirectSaleSummaryPeriod(
  params: ReportDirectSaleSaleSummaryFormValues,
) {
  const response = (await api.get(
    `${BASE_URL}/sales-summary/period-data`,
    params,
  )) as unknown;
  return response as DirectSaleSummaryPeriodDataRequest[];
}

export async function generateDirectSaleSummarySituation(
  params: ReportDirectSaleSaleSummaryFormValues,
) {
  const response = (await api.get(
    `${BASE_URL}/sales-summary/situation-data`,
    params,
  )) as unknown;
  return response as DirectSaleDataRequest[];
}

export async function generateDirectSaleSeller(
  params: ReportDirectSaleSaleSummaryFormValues,
) {
  const response = (await api.get(
    `${BASE_URL}/sales-seller/data`,
    params,
  )) as unknown;
  return response as DirectSaleTotalDataRequest[];
}

export async function generateDirectSaleSellerSynthetic(
  params: ReportDirectSaleSaleSummaryFormValues,
) {
  const response = (await api.get(
    `${BASE_URL}/sales-seller-synthetic/data`,
    params,
  )) as unknown;
  return response as DirectSaleSellerSyntheticDataRequest[];
}

export async function generateDirectSalePaymentReceipt(
  params: ReportDirectSalePaymentReceipt,
) {
  const response = (await api.getReport(
    `${BASE_URL}/sales/${params.saleId}/payment-receipt`,
    params,
  )) as unknown;

  return response as BlobPart;
}
